import React, { useState } from 'react';
import styles from './HeaderMenu.module.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectedDey } from '../../store/slices/showMenuSlice';
import LoaderPage from '../LoaderPage/LoaderPage';
import { pathHome } from '../../path';

export default function HeaderMenu({ showMenu }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { group_id } = useParams();
  const [showList, setShowList] = useState(false);
  const [loader, setLoader] = useState(false);

  const indexRenderMenuDey = useSelector((state) => state.showMenu.indexRenderMenuDey);

  // Вибір конкретного дня
  const selectedMenuDay = (itemKey) => {
    setLoader(true);
    setShowList(false);
    dispatch(selectedDey(itemKey));

    setTimeout(() => {
      setLoader(false);
    }, 200);
  };

  // console.log('indexRenderMenuDey ===', indexRenderMenuDey);
  // console.log('showMenu ====', showMenu);

  // Рендерить список днів меню
  const renderSelectedList = (menu) => {
    // console.log('list ==== ', list);
    const list = Object.keys(menu);

    return list.map((item) => {
      return item === indexRenderMenuDey ? (
        <div key={menu[item].id} className={styles.selected_list_item + ' ' + styles.active}>
          День {menu[item].dayNumber > 0 ? menu[item].dayNumber : '-'}
        </div>
      ) : (
        <div
          key={menu[item].id}
          className={styles.selected_list_item + ' ' + styles.interaction_item}
          onClick={() => selectedMenuDay(item)}>
          День {menu[item].dayNumber > 0 ? menu[item].dayNumber : '-'}
        </div>
      );
    });
  };

  const getKeyRenderDay = (transition, indexRenderMenuDey, showMenu) => {
    const menyKeys = Object.keys(showMenu);

    for (let index = 0; index < menyKeys.length; index++) {
      const itemKey = menyKeys[index];

      if (itemKey === indexRenderMenuDey) {
        if (transition === 'back') {
          return menyKeys[index - 1];
        }
        if (transition === 'next') {
          return menyKeys[index + 1];
        }
      }
    }

    return false;
  };

  return (
    <>
      <div className={styles.header_wrapper}>
        <div
          className={styles.header_back_btn}
          onClick={() => navigate(`/${pathHome}/group/` + group_id)}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.99999L11.25 0.339737V17.6602L0 8.99999Z" fill="white" />
          </svg>
          Назад
        </div>
        <div className={styles.selected_wrapper}>
          {getKeyRenderDay('back', indexRenderMenuDey, showMenu) ? (
            <svg
              onClick={() => selectedMenuDay(getKeyRenderDay('back', indexRenderMenuDey, showMenu))}
              className={styles.interaction_item}
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.999998 13.732C-0.333335 12.9622 -0.333333 11.0377 1 10.2679L17.5 0.741669C18.8333 -0.0281316 20.5 0.93412 20.5 2.47372V21.5263C20.5 23.0659 18.8333 24.0281 17.5 23.2583L0.999998 13.732Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              className={styles.opacity_0}
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.999998 13.732C-0.333335 12.9622 -0.333333 11.0377 1 10.2679L17.5 0.741669C18.8333 -0.0281316 20.5 0.93412 20.5 2.47372V21.5263C20.5 23.0659 18.8333 24.0281 17.5 23.2583L0.999998 13.732Z"
                fill="white"
              />
            </svg>
          )}

          <div className={styles.selected_day_wrapper}>
            {showMenu && Object.keys(showMenu).length ? (
              <div
                className={styles.selected_day + ' ' + styles.interaction_item}
                onClick={() => setShowList(!showList)}>
                День{' '}
                {indexRenderMenuDey && showMenu[indexRenderMenuDey].dayNumber > 0
                  ? showMenu[indexRenderMenuDey].dayNumber
                  : '-'}
                <svg
                  className={false ? styles.show : ''}
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.60218 10.8556C8.80231 11.9262 7.19769 11.9262 6.39782 10.8556L0.86245 3.44708C-0.122997 2.12816 0.81822 0.25 2.46463 0.25H13.5354C15.1818 0.25 16.123 2.12816 15.1375 3.44709L9.60218 10.8556Z"
                    fill="white"
                  />
                </svg>
              </div>
            ) : (
              <div className={styles.selected_day}>Пусто:)</div>
            )}

            {showList && showMenu && Object.keys(showMenu).length ? (
              <div className={styles.selected_list}>{renderSelectedList(showMenu)}</div>
            ) : (
              ''
            )}
          </div>

          {getKeyRenderDay('next', indexRenderMenuDey, showMenu) ? (
            <svg
              onClick={() => selectedMenuDay(getKeyRenderDay('next', indexRenderMenuDey, showMenu))}
              className={styles.interaction_item}
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 10.268C21.3333 11.0378 21.3333 12.9623 20 13.7321L3.5 23.2583C2.16667 24.0281 0.5 23.0659 0.5 21.5263V2.47372C0.5 0.934118 2.16667 -0.0281307 3.5 0.74167L20 10.268Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              className={styles.opacity_0}
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 10.268C21.3333 11.0378 21.3333 12.9623 20 13.7321L3.5 23.2583C2.16667 24.0281 0.5 23.0659 0.5 21.5263V2.47372C0.5 0.934118 2.16667 -0.0281307 3.5 0.74167L20 10.268Z"
                fill="white"
              />
            </svg>
          )}
        </div>
        <Link to={`/${pathHome}/addMenu/${group_id}`}>
          <svg
            className={styles.interaction_item}
            width="35"
            height="36"
            viewBox="0 0 35 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect y="2.60376" width="34.7273" height="33.0189" rx="10" fill="#A22CA7" />
            <path
              d="M16.2182 26.4091V11.4091H18.7636V26.4091H16.2182ZM9.99089 20.1818V17.6364H24.9909V20.1818H9.99089Z"
              fill="white"
            />
          </svg>
        </Link>
      </div>
      {loader && <LoaderPage />}
    </>
  );
}
